angular.module('aprima-provider-api').factory('AppointmentRepository',
    ['AprimaRestangular', 'MetadataRepository', '$q', 'moment', 'AprimaAnalytics', 'SingleAccessSet',
        function (AprimaRestangular, MetadataRepository, $q, moment, AprimaAnalytics, SingleAccessSet) {
            'use strict';

            var apptListeners = [];
            var modifiedCalendarIdsForCalendarList = new SingleAccessSet();
            var modifiedCalendarIdsForDashboard = new SingleAccessSet();

            function getAppointment (uid, appComponent, subRoute) {
                var timing = AprimaAnalytics.startTiming(appComponent || 'AppointmentRepository', 'api', 'getAppointment');

                var restangular = AprimaRestangular.get();
                return restangular.all('appointments' + (subRoute || '')).one(uid).get().then(function(appt){

                    //for dealing with date funkiness, and avoiding adding dependencies elsewhere
                    appt.getClone = function getClone() {
                        return restangular.copy(appt);
                    };

                    return appt;
                }).finally(timing.stop);
            }

            function getPatientAppointment (uid, appComponent) {
                return getAppointment(uid, appComponent);
            }

            function getGroupAppointment (uid, appComponent) {
                return getAppointment(uid, appComponent, '/group-visit');
            }

            function getEventAppointment (uid, appComponent) {
                return getAppointment(uid, appComponent, '/event');
            }

            function getBlockingEventAppointment (uid, appComponent) {
                return getAppointment(uid, appComponent, '/blocking-event');
            }

            function getAppointmentMetadata ($scope) {
                var timing = AprimaAnalytics.startTiming('AppointmentRepository', 'api', 'getAppointmentMetadata');
                return MetadataRepository.getMetadata('appointmentdetail', $scope).finally(timing.stop);
            }

            function getGroupAppointmentMetadata ($scope) {
                var timing = AprimaAnalytics.startTiming('AppointmentRepository', 'api', 'getAppointmentMetadata');
                return MetadataRepository.getMetadata('groupvisitappointment', $scope).finally(timing.stop);
            }

            function getBlockingEventAppointmentMetadata ($scope) {
                var timing = AprimaAnalytics.startTiming('AppointmentRepository', 'api', 'getAppointmentMetadata');
                return MetadataRepository.getMetadata('blockingeventappointment', $scope).finally(timing.stop);
            }

            function getEventAppointmentMetadata ($scope) {
                var timing = AprimaAnalytics.startTiming('AppointmentRepository', 'api', 'getAppointmentMetadata');
                return MetadataRepository.getMetadata('eventappointment', $scope).finally(timing.stop);
            }

            var updateAppointment = function (appt) {
                var timing = AprimaAnalytics.startTiming('AppointmentRepository', 'api', 'updateAppointment');
                return appt.put()
                    .finally(timing.stop)
                    .finally(function() {
                        if(appt.Calendar) {
                            modifiedCalendarIdsForCalendarList.add(appt.Calendar.Id);
                            modifiedCalendarIdsForDashboard.add(appt.Calendar.Id);
                        }
                    });
            };

            var createAppointment = function (appt, subRoute) {
                var timing = AprimaAnalytics.startTiming('AppointmentRepository', 'api', 'createAppointment');
                return AprimaRestangular.get().all('appointments' + (subRoute || ''))
                    .post(appt)
                    .finally(timing.stop)
                    .finally(function() {
                        if(appt.Calendar) {
                            modifiedCalendarIdsForCalendarList.add(appt.Calendar.Id);
                            modifiedCalendarIdsForDashboard.add(appt.Calendar.Id);
                        }
                    });
            };
            //TODO: fill in these methods below with correct logic

            function updatePatientAppointment (appt) {
                return updateAppointment(appt);
            }

            function updateGroupAppointment (appt) {
                return updateAppointment(appt);
            }

            function updateEventAppointment (appt) {
                return updateAppointment(appt);
            }

            function updateBlockingEventAppointment (appt) {
                return updateAppointment(appt);
            }

            function createPatientAppointment (appt) {
                return createAppointment(appt);
            }

            function createGroupAppointment (appt) {
                return createAppointment(appt, '/group-visit');
            }

            function createEventAppointment (appt) {
                return createAppointment(appt, '/event');
            }

            function createBlockingEventAppointment (appt) {
                return createAppointment(appt, '/blocking-event');
            }

            function getDashboardAppointments(calendar, restangularOptions, appComponent) {
                if(angular.isString(restangularOptions)) {
                    appComponent = restangularOptions;
                    restangularOptions = null;
                }

                restangularOptions = restangularOptions || { ignoreCache: false };

                var calendarId = calendar.Id || null;
                var options = {
                    date: moment().format('MM-DD-YYYY'),
                    offsetMinutes: moment().utcOffset()
                };

                restangularOptions.ignoreCache = modifiedCalendarIdsForDashboard.contains(calendarId) || restangularOptions.ignoreCache;

                return getAppointmentsInternal(calendarId, options, restangularOptions, appComponent);

            }

            function addListener(callback) {
                if (apptListeners && callback && apptListeners.indexOf(callback) < 0) {
                    apptListeners.push(callback);
                }
            }

            function removeListener(callback) {
                if (apptListeners && callback && apptListeners.indexOf(callback) >= 0) {
                    apptListeners.pop(callback);
                }
            }

            function getAppointments(calendarId, params, restangularOptions, appComponent) {
                if(angular.isString(restangularOptions)) {
                    appComponent = restangularOptions;
                    restangularOptions = null;
                }

                restangularOptions = restangularOptions || { ignoreCache: false };

                restangularOptions.ignoreCache = modifiedCalendarIdsForCalendarList.contains(calendarId) || restangularOptions.ignoreCache;

                return getAppointmentsInternal(calendarId, params, restangularOptions, appComponent);
            }

            function getAppointmentsInternal (calendarId, params, restangularOptions, appComponent) {
                var timing = AprimaAnalytics.startTiming(appComponent || 'AppointmentRepository', 'api', 'getAppointments');
                if (calendarId) {
                    return AprimaRestangular.get(restangularOptions)
                        .all('calendars/' + calendarId + '/appointments')
                        .getList(params)
                        .finally(timing.stop);
                }

                return $q.when([]);
            }

            return {
                getAppointmentDetails: getPatientAppointment,
                getAppointmentMetadata: getAppointmentMetadata,
                getDashboardAppointments: getDashboardAppointments,
                getAppointments: getAppointments,
                getGroupAppointmentMetadata: getGroupAppointmentMetadata,
                getBlockingEventAppointmentMetadata: getBlockingEventAppointmentMetadata,
                getEventAppointmentMetadata: getEventAppointmentMetadata,
                getGroupAppointment: getGroupAppointment,
                getEventAppointment: getEventAppointment,
                addListener: addListener,
                removeListener: removeListener,
                getBlockingEventAppointment: getBlockingEventAppointment,
                updatePatientAppointment: updatePatientAppointment,
                createPatientAppointment: createPatientAppointment,
                updateGroupAppointment: updateGroupAppointment,
                createGroupAppointment: createGroupAppointment,
                updateEventAppointment: updateEventAppointment,
                createEventAppointment: createEventAppointment,
                updateBlockingEventAppointment: updateBlockingEventAppointment,
                createBlockingEventAppointment: createBlockingEventAppointment
            };
        }]);
